import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Homepage from 'src/component/Homepage';
import CoursePage from 'src/component/CoursePage';
import NavigationBar from 'src/component/NavigationBar';
import CourseLessonPage from 'src/component/CourseLessonPage';

export default function App() {
  return (
    <BrowserRouter>
      <NavigationBar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="course">
          <Route path=":courseId" element={<CoursePage />} />
          <Route path=":courseId/:courseChapterId/:courseLessonId" element={<CourseLessonPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
